// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option[data-v-5971afd3]{margin:0 0 20px 20px}.option .el-button[data-v-5971afd3]{min-height:0;background:#1c6de4;border-radius:3px;font-size:12px;color:#fff;padding:12px 20px;border:0}.option .el-button .custom-icon[data-v-5971afd3]{font-size:18px;vertical-align:text-bottom}", ""]);
// Exports
module.exports = exports;
